import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ConfirmDialogDATA {
  title: string,
  descriptions: string[],
  lastTitle: string | number,
  isError: boolean,
  type?: string,
  translate: {
    title: string,
    descriptions: string[],
    close: string,
    postive: string,
    negative: string,
    isDelete: boolean
  }
}

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
  reference: ConfirmDialogDATA

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogDATA>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogDATA
  ) { }

  ngOnInit(): void {
    this.reference = Object.assign({ translate: { descriptions: [] } }, this.data);
  }

  closeDialog(type: string): void {
    this.dialogRef.close({ status: type == 'close'? null : false });
  }

  _handleClose(): void {
    this.dialogRef.close({ data: this.data, status: true });
  }
}
